import { definedMap } from "@glideapps/ts-necessities";

import { BaseFieldMaterialRenderer } from "./base-field-material-renderer";
import { asString } from "common/components/component-helpers";
import { PotentialValue, Value } from "common/components/types";
import { isValidEmailAddress, normalizeEmailAddress } from "common/Support";
import { getLocalizedString } from "common/components/localization";
import { GlideFunctionalRenderer } from "common/components/uis";

export const EmailFieldMaterialRenderer: GlideFunctionalRenderer = p => {
    const convertIn = (input: Value): string => {
        return definedMap(input, asString) ?? "";
    };

    const getErrorMessage = (
        input: string,
        isRequired: boolean,
        _args: readonly PotentialValue[]
    ): string | undefined => {
        const normalized = normalizeEmailAddress(input);
        if (normalized === "" && !isRequired) return undefined;
        return isValidEmailAddress(normalized) ? undefined : getLocalizedString("pleaseEnterValidEmail");
    };

    return (
        <BaseFieldMaterialRenderer {...p} dataType="email" convertIn={convertIn} getErrorMessage={getErrorMessage} />
    );
};
